import axios from "axios";
import { LOCAL_STORAGE_KEYS } from "../constants/local-storage-keys";

const AUNJAI_SOURCE_CODE_BASE_URL = process.env.REACT_APP_SC_API_ENDPOINT;
const AUNJAI_BACKEND_BASE_URL = process.env.REACT_APP_NOTIFICATION_API_ENDPOINT;

console.log("AUNJAI_SOURCE_CODE_BASE_URL >>", AUNJAI_SOURCE_CODE_BASE_URL);
console.log("AUNJAI_BACKEND_BASE_URL >>", AUNJAI_BACKEND_BASE_URL);

const aunjaiSourceCodeClient = axios.create({
  validateStatus: () => true,
  baseURL: AUNJAI_SOURCE_CODE_BASE_URL,
});

aunjaiSourceCodeClient.interceptors.request.use((config) => {
  const authToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);

  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
}

  return config;
});

const aunjaiBackendClient = axios.create({
  validateStatus: () => true,
  baseURL: AUNJAI_BACKEND_BASE_URL,
});

export { aunjaiSourceCodeClient, aunjaiBackendClient };
